//  Node imports
import { SlotEventConstants, SymbolBase } from "@quest/slot-core";
import { IEvent, IObject, dispatcher, toInt } from "@quest/base-core";
import { ReelPanelController, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist";

//  Class imports
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

/**
 * ReelPanelControllerGame class hanles the slot reel functionality for the base game.
 */
export class ReelPanelControllerGame extends ReelPanelController {

  /**
   * method onSpinReel overrided to control sound
   */
  protected onSpinReel(evt: IEvent): void {
    super.onSpinReel(evt);
    this.fadeBaseGameSound();
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_ELEMENTS); // Add to reset progress bar
  }


  /**
   * overrided to remove unsubscribe of SHOW_ANTICIPATION
   * to start bigwin blast
   */
  protected onSpinComplete(evt?: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
    ingenuity.configData.spinComplete = true;
    this.reelView.getModel().quickSpin = false;
    this.reelView.setStopNow(false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_WIN_AFTER_REEL_STOP);
    // only this line commented from base class function
    //dispatcher.off(SlotEventConstants.SHOW_ANTICIPATION, this.showAnticipation);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_SPIN_STOP_PLAYER_MSG);
    if (!this.model.getIsWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
    }
    if ((ingenuity.parserModel as GameParserModel).getIsJackpotWonBG()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_AUTOPLAY_BEFORE_FEATURE);
    }
		window.parent.postMessage({name: 'slot.spin_completed', data: {slotType: 'iframe', developer: 'luckyzino'}}, "*");
  }

  /**
   * onReelStopped method overrided to play anticipation sound.
   * @param evt 
   */
  protected onReelStopped(evt: IEvent): void {
    super.onReelStopped(evt);
    if (toInt(evt.toString()) === 4) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.ANTICIPATION_SOUND, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  /**
  * overrided to send landing symbols data on every reel
  */
  protected onReelStoping(evt?: IEvent): void {
    // const volLevel = 0.8;
    const reelNo: number = toInt(evt.toString());
    this.view.clearAnticipation();
    const value = ingenuity.parserModel.getLandingSoundOnReel()[0][toInt(evt.toString())];
    if (value === undefined && !ingenuity.configData.isPlayAnticipationSound && !this.model.getIsTurboModeOn()) {
        ingenuity.soundManager.playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    if (this.model.getIsTurboModeOn() && (toInt(evt.toString()) === 0)) {
        ingenuity.soundManager.playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    if (ingenuity.configData.isPlayAnticipationSound) {
      // Play anticipation reel stop sound
      (ingenuity.soundManager as any).playSound(SoundConstantGame.ANTICIPATION_REEL_STOP, 1, false, gameConstants.SOUND_LIST_PRELOAD);
    }
    for (let m: number = 0; m < (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel().length; m++) {
      const value: IObject = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[m][reelNo];
      value && dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS, [value, (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()]);
    }
    if (this.reelView.getModel().landingOnReel[reelNo] && (this.reelView.getModel().landingOnReel[reelNo] === 1)) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_LANDINGANIMATION, [this.model.getReelGrid(), this.reelView, reelNo]);
    }
    if (
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] &&
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] === 1 &&
      !ingenuity.configData.spinStopPressed
    ) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_ANTICIPATION, toInt(evt.toString()) + 1);
      this.fadeSymbolOnAnticipation(toInt(evt.toString()));
      ingenuity.configData.currentAnticipation = toInt(evt.toString()) + 1;
    }
    // to unfade all reels on last reel stopping
    if (toInt(evt.toString()) === 4) {
      this.unFadeSymbolAfterAnticipation();
    }
  }

  /**
  * to unfade symbol  on reels after anticipation ends
  */
  private unFadeSymbolAfterAnticipation(): void {
    let numOfReel: number = this.reelView.getModel().numReels;
    let reelGrid: any[] = this.model.getReelGrid();
    for (let i: number = 0; i < numOfReel; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        this.reelView.getSymbolByPos(i, j).getStatic().tint = gameConstants.UNFADED_SYMBOL;
        if (reelGrid[i][j] === gameConstants.POT_SYMBOL) {
          this.unFadePotLandingSpine(this.reelView.getSymbolByPos(i, j));
        }
      }
    }
  }

  /**
   *  Method unFadePotLandingSpine to unfade Pot symbol landing anim
   * */
  private unFadePotLandingSpine(symbol:SymbolBase): void {
    const container= symbol.getAnimation().children;
    const tintValue = gameConstants.UNFADED_SYMBOL;
    container.forEach((value: any) => {
      value.parent.tint = tintValue;
        }, this); 
    }

  /**
   *  playAnticipationSound method plays the anticipation sound.
   */
  protected playAnticipationSound(): void {
    if (!ingenuity.configData.isPlayAnticipationSound) {
      ingenuity.configData.isPlayAnticipationSound = true;
      (ingenuity.soundManager as any).play(SoundConstantGame.ANTICIPATION_SOUND, 1, true, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  /**
   *  To show faded symbol except for Free Spin symbols on reels during anticipation
   * */
  private fadeSymbolOnAnticipation(reel: number): void {
    let numOfReel: number = reel;
    let reelGrid: any[] = this.model.getReelGrid();
    for (let i: number = 0; i <= numOfReel; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === gameConstants.POT_SYMBOL) {
          this.fadePotLandingSpine(this.reelView.getSymbolByPos(i, j));
        }
        if (reelGrid[i][j] !== gameConstants.FREESPIN_SYMBOL_GAME) {
          this.reelView.getSymbolByPos(i, j).getStatic().tint = gameConstants.FADED_SYMBOL;
        }
      }
    }
  }

   /**
   *  Method fadePotLandingSpine to fade Pot symbol landing anim
   * */
  private fadePotLandingSpine(symbol:SymbolBase): void {
    const container= symbol.getAnimation().children;
    const tintValue = gameConstants.FADED_SYMBOL;
    container.forEach((value: any) => {
      value.parent.tint = tintValue;
        }, this); 
    }

  /**
   *  override to check for anticipation
   * */
  protected checkForAnticipation(symbolObj: any, listLength: number): void {
    let i: number, j: number, k: number, n: number;
    let symbolCount: number = 0;
    let anticipation: number[] = [];
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      this.reelView.getModel().anticipationSpin[i] = 0;
      if (symbolObj.aniticipationRunOnReel[i] != 0) {
        if (symbolCount >= symbolObj.symbolCount && symbolObj.aniticipationRunOnReel[i] !== -1) {
          if (ingenuity.configData.anticipationRunAfterFeature) {
            anticipation[i] = 1;
          }
          else {
            if (symbolCount >= symbolObj.symbolCount + 1) {
              anticipation[i] = 0;
            }
            else {
              anticipation[i] = 1;
            }
          }
        }
      }
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (this.model.getReelGrid()[i][j] === symbolObj.symbolId && symbolObj.aniticipationRunOnReel[i] !== -1) {
          symbolCount++;
        }
      }
    }
    this.anticipationList.push(anticipation);
    if (this.anticipationList.length === listLength) {
      for (k = 0; k < this.anticipationList.length; k++) {
        for (n = 0; n < this.anticipationList[k].length; n++) {
          if (this.anticipationList[k][n] === 1) {
            this.reelView.getModel().anticipationSpin[n] = 1;
          }
        }
      }
    }
    this.checkForlandingAnim(symbolObj, listLength);
  }

  //override to check landing animation for pot symbol
  protected checkForlandingAnim(symbolObj:IObject, listLength:number) {
    let i, j;
    let symbolCount = 0;
    let symbolFound = false;
    const symbolNeeded = symbolCount + 1;
    const NumReel = this.reelView.getModel().numReels;
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
        for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
            if (this.model.getReelGrid()[i][j] === symbolObj.symbolId || this.model.getReelGrid()[i][j] === gameConstants.POT_SYMBOL) {
                symbolFound = true;
                break;
            }
        }
        if (symbolFound) {
            symbolCount++;
            if (symbolFound && i < (NumReel - (symbolNeeded - symbolCount))) {
                this.reelView.getModel().landingOnReel[i] = 1;
            }
            symbolFound = false;
        }
    }
}

   /**
   * Method fadeBaseGameSound to fade and stop base game BGM and intro sound.
   */
   private fadeBaseGameSound(): void {
    const audioController: any = (ingenuity.soundManager as any);
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = 0;
    } else {
      audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, 0, true, gameConstants.SOUND_LIST_PRELOAD);
    };
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    };
  }
}
